import { getStopApi } from '../../../../../../../services/StopApi/StopApi';
import moment from 'moment';
import { dateFormat } from '../../../../../../../constants';

export const getSapActivitiesAndInvoicesList = async ({
  commonParams,
  authorization,
  getContactName,
  getContactPhone,
  getContactFax,
}) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const sapActivities = response.data.sapActivities;
    const sapInvoices = response.data.sapInvoices;
    return {
      isLoading: false,
      sapActivitiesListData: sapActivities?.map((item, index) => ({
        ...item,
        _id: index,
        orgCntId: item.orgCntId,
        contactKeyId: item.contactKey,
        contactKey: getContactName(item.contactKey),
        phone: getContactPhone(item.contactKey),
        fax: getContactFax(item.contactKey),
      })),
      sapInvoicesListData: sapInvoices?.map((item, index) => ({
        ...item,
        _id: index,
        invId: item.invId,
        amount: item.amount,
        date: item.date
          ? moment(item.date).format(dateFormat).split('T')[0]
          : '-',
        dateCreated: item.dateCreated
          ? moment(item.dateCreated).format(dateFormat).split('T')[0]
          : '-',
        dateSent: item.dateSent
          ? moment(item.dateSent).format(dateFormat).split('T')[0]
          : '-',
        dateStart: item.dateStart
          ? moment(item.dateStart).format(dateFormat).split('T')[0]
          : '-',
      })),
    };
  }).catch((e) => alert(e));
};
